import React, {useEffect, useState} from 'react';
import {Message} from "types/Message";
import ConfirmModal from "components/ConfirmModal";
import {invalidate} from "services/query-client";
import {useMutation} from "react-query";
import ngage from "services/ngage";
import {useNotifications} from "context/NotificationContext";

type Props = {
    message: Message | null
    show: boolean
    onDelete?: (message: Message) => any
    onDeleteFail?: (message: Message, error: unknown) => any
    onCancel?: () => any
}

function DeleteMessage({message, show, onDelete, onDeleteFail, onCancel}: Props) {
    const {notify} = useNotifications()

    const [subject, setSubject] = useState<string>(message?.subject || 'this message');
    const {mutateAsync: deleteMessage} = useMutation(ngage.messages.destroy)

    useEffect(() => {
        if(message) setSubject(message.subject)
    }, [message]);

    async function handleDeleteMessage() {
        if (message) {
            try {
                await deleteMessage(message.id)
                await invalidate('messages.all')

                notify("success", "Message Deleted", `${message.subject} has been permanently removed`)

                if (onDelete) onDelete(message)
            } catch (error) {
                notify("error", "Message Not Deleted", `${message.subject} could not be removed`)

                if (onDeleteFail) onDeleteFail(message, error)
            }
        }
    }

    function handleCancel() {
        if (onCancel) onCancel()
    }

    return (
        <ConfirmModal
            show={show}
            type={ConfirmModal.types.DANGER}
            title="Delete message"
            body={`Are you sure you want to permanently delete '${subject}'? This action cannot be undone.`}
            approveLabel="Delete"
            onApprove={handleDeleteMessage}
            onCancel={handleCancel}
        />
    );
}

export default DeleteMessage;